import {
	Grid,
	Theme,
	AppBar,
	Toolbar,
	Typography,
	Container,
} from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import Alerts from "./Alerts";
import UpcomingClasses from "./UpcomingClasses";
import Profile from "./Profile";

const useStyles = makeStyles((theme: Theme) => ({
	paper: {
		padding: 20,
		marginTop: 40,
		paddingBottom: 70,
		[theme.breakpoints.up("md")]: {
			paddingLeft: 70,
			marginTop: 30,
		},
		width: "100%",
	},
	avatar: {
		margin: theme.spacing(1),
		backgroundColor: theme.palette.secondary.main,
	},
	form: {
		width: "100%", // Fix IE 11 issue.
		marginTop: theme.spacing(1),
	},
	submit: {
		margin: theme.spacing(3, 0, 0),
	},
	appBar: {
		justifyContent: "center",
		top: 55,
		bottom: "auto",
		height: "55px",
		zIndex: 1,
	},
	toolbar: {
		justifyContent: "space-between",
	},
	marginLeft: {
		[theme.breakpoints.up("md")]: {
			marginLeft: 45,
		},
	},
}));

export default function Dashboard() {
	const classes = useStyles();
	return (
		<Grid
			direction="row"
			className={classes.paper}
			container
			justifyContent="center"
		>
			<AppBar className={classes.appBar} position="fixed">
				<Toolbar className={classes.toolbar}>
					<Typography />
					<Typography
						component="h3"
						variant="h5"
						align="center"
						className={classes.marginLeft}
						style={{ color: "white" }}
					>
						Dashboard
					</Typography>
					<Typography />
				</Toolbar>
			</AppBar>
			<Container maxWidth="lg">
				<Grid container justifyContent="center">
					<Grid sx={{ mt: 5 }} item xs={12} md={10}>
						<Alerts />
					</Grid>
					<Grid item xs={12} md={10}>
						<Profile />
					</Grid>
					<Grid item xs={12} md={10}>
						<UpcomingClasses />
					</Grid>
				</Grid>
			</Container>
		</Grid>
	);
}
